/**
 * Кастомная ошибка для offline-состояния.
 * Используется для идентификации сетевых проблем в HTTP-клиенте.
 */
export class OfflineError extends Error {
  public readonly isOfflineError = true
  public readonly statusCode: number = 0

  constructor(message: string = 'Нет подключения к интернету') {
    super(message)
    this.name = 'OfflineError'
    // Корректный instanceof для кастомных ошибок в TypeScript
    Object.setPrototypeOf(this, OfflineError.prototype)
  }

  static isOfflineError(error: unknown): error is OfflineError {
    return (
      (error as any)?.isOfflineError === true ||
      (error as any)?.name === 'OfflineError'
    )
  }

  static fromFetchError(error: unknown): OfflineError {
    const msg = (error as any)?.message ?? ''
    const code = (error as any)?.cause?.code ?? ''

    if (
      msg.includes('fetch') ||
      msg.includes('network') ||
      msg.includes('Failed to fetch') ||
      code === 'ECONNREFUSED' ||
      code === 'ENOTFOUND' ||
      code === 'ETIMEDOUT'
    ) {
      return new OfflineError('Проблема с подключением к серверу')
    }

    return new OfflineError()
  }
}
